import "../../util-b2b0dc25.js";
import "vue";
import o from "./popup/popup-manager.js";
import i from "./popper.js";
import "./dom.js";
const l = {
  props: {
    transformOrigin: {
      type: [Boolean, String],
      default: !0
    },
    placement: {
      type: String,
      default: "bottom"
    },
    boundariesPadding: {
      type: Number,
      default: 5
    },
    reference: {},
    popper: {},
    offset: {
      default: 0
    },
    value: Boolean,
    visibleArrow: Boolean,
    arrowOffset: {
      type: Number,
      default: 35
    },
    appendToBody: {
      type: Boolean,
      default: !0
    },
    popperOptions: {
      type: Object,
      default() {
        return {
          gpuAcceleration: !1
        };
      }
    }
  },
  data() {
    return {
      showPopper: !1,
      currentPlacement: ""
    };
  },
  watch: {
    value: {
      immediate: !0,
      handler(e) {
        this.showPopper = e, this.$emit("input", e);
      }
    },
    showPopper(e) {
      this.disabled || (e ? this.updatePopper() : this.destroyPopper(), this.$emit("input", e));
    }
  },
  methods: {
    createPopper() {
      if (this.$isServer || (this.currentPlacement = this.currentPlacement || this.placement, !/^(top|bottom|left|right)(-start|-end)?$/g.test(this.currentPlacement)))
        return;
      const e = this.popperOptions, r = this.popperElm = this.popperElm || this.popper || this.$refs.popper;
      let t = this.referenceElm = this.referenceElm || this.reference || this.$refs.reference;
      !t && this.$slots.reference && this.$slots.reference[0] && (t = this.referenceElm = this.$slots.reference[0].elm), !(!r || !t) && (this.visibleArrow && this.appendArrow(r), this.appendToBody && document.body.appendChild(this.popperElm), this.popperJS && this.popperJS.destroy && this.popperJS.destroy(), e.placement = this.currentPlacement, e.offset = this.offset, e.arrowOffset = this.arrowOffset, this.popperJS = new (i())(t, r, e), this.popperJS.onCreate((p) => {
        this.$emit("created", this), this.resetTransformOrigin(), this.$nextTick(this.updatePopper);
      }), typeof e.onUpdate == "function" && this.popperJS.onUpdate(e.onUpdate), this.popperJS._popper.style.zIndex = o.nextZIndex(), this.popperElm.addEventListener("click", stop));
    },
    updatePopper() {
      const e = this.popperJS;
      e ? (e.update(), e._popper && (e._popper.style.zIndex = o.nextZIndex())) : this.createPopper();
    },
    doDestroy(e) {
      !this.popperJS || this.showPopper && !e || (this.popperJS.destroy(), this.popperJS = null);
    },
    destroyPopper() {
      this.popperJS && this.resetTransformOrigin();
    },
    resetTransformOrigin() {
      if (!this.transformOrigin)
        return;
      let e = {
        top: "bottom",
        bottom: "top",
        left: "right",
        right: "left"
      }, r = this.popperJS._popper.getAttribute("x-placement").split("-")[0], t = e[r];
      this.popperJS._popper.style.transformOrigin = typeof this.transformOrigin == "string" ? this.transformOrigin : ["top", "bottom"].indexOf(r) > -1 ? `center ${t}` : `${t} center`;
    },
    appendArrow(e) {
      let r;
      if (this.appended)
        return;
      this.appended = !0;
      for (let p in e.attributes)
        if (/^_v-/.test(e.attributes[p].name)) {
          r = e.attributes[p].name;
          break;
        }
      const t = document.createElement("div");
      r && t.setAttribute(r, ""), t.setAttribute("x-arrow", ""), t.className = "popper__arrow", e.appendChild(t);
    }
  },
  beforeDestroy() {
    this.doDestroy(!0), this.popperElm && this.popperElm.parentNode === document.body && (this.popperElm.removeEventListener("click", stop), document.body.removeChild(this.popperElm));
  },
  // call destroy in keep-alive mode
  deactivated() {
    this.$options.beforeDestroy[0].call(this);
  }
};
export {
  l as default
};
